var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-default m-salesKPIRecord" },
    [
      _c(
        "div",
        { staticClass: "wrap-container left-container" },
        [
          _c(
            "InfoItem",
            {
              attrs: {
                title: "" + _vm.$t("storeComponents.title.sales"),
                "without-drop": "",
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "tppDataForm",
                  staticClass: "formGroup",
                  attrs: {
                    model: _vm.salesForm,
                    size: "small",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "radioGroup",
                          model: {
                            value: _vm.salesForm.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.salesForm, "type", $$v)
                            },
                            expression: "salesForm.type",
                          },
                        },
                        [
                          _c(
                            "el-radio-button",
                            { attrs: { label: "1", name: "type" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("storeComponents.tab.month"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "2", name: "type" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("storeComponents.tab.quarter"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "3", name: "type" } },
                            [_vm._v(_vm._s(_vm.$t("storeComponents.tab.year")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("storeComponents.select.brand") },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.salesForm.brand,
                          options: _vm.ssbtypeOptions,
                          clearable: false,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.salesForm, "brand", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.formatTimeLabel } },
                    [
                      _vm.salesForm.type == "1"
                        ? _c("FormDatePicker", {
                            attrs: {
                              val: _vm.salesForm.value,
                              valueformat: "yyyyMM",
                              type: "month",
                              clearable: false,
                              editable: false,
                              placeholder: _vm.$t(
                                "storeComponents.common.pleaseSelectMonth"
                              ),
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(_vm.salesForm, "value", $event)
                              },
                            },
                          })
                        : _vm.salesForm.type == "2"
                        ? _c("FormQuarterPicker", {
                            attrs: {
                              val: _vm.salesForm.value,
                              placeholder: _vm.$t(
                                "storeComponents.common.pleaseSelectQuarter"
                              ),
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(_vm.salesForm, "value", $event)
                              },
                            },
                          })
                        : _vm.salesForm.type == "3"
                        ? _c("FormDatePicker", {
                            attrs: {
                              val: _vm.salesForm.value,
                              valueformat: "yyyy",
                              type: "year",
                              clearable: false,
                              editable: false,
                              placeholder: _vm.$t(
                                "storeComponents.common.pleaseSelectYear"
                              ),
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(_vm.salesForm, "value", $event)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("div", { staticClass: "desc" }, [
                    _c("span", { staticClass: "desc" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "storeComponents.common.desc" + _vm.salesForm.type
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "el-icon-warning-outline" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tab flex" },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "radioGroup",
                          staticStyle: { width: "28%" },
                          model: {
                            value: _vm.isSales,
                            callback: function ($$v) {
                              _vm.isSales = $$v
                            },
                            expression: "isSales",
                          },
                        },
                        [
                          _c(
                            "el-radio-button",
                            { attrs: { label: "sales", name: "type" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("storeComponents.tab.sales"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "integral", name: "type" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("storeComponents.tab.score"))
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            icon: "el-icon-set-up",
                            type: "primary",
                          },
                          on: { click: _vm.clickShowSalary },
                        },
                        [_vm._v(_vm._s(_vm.$t("dashboard.bonus.title")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("HeaderMore", {
                    staticClass: "mt_20",
                    attrs: {
                      title: _vm.$t("storeComponents.title.saleDisplay"),
                      "no-title": "",
                      "no-more": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tppChartBox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isSales === "store",
                            expression: "isSales === 'store'",
                          },
                        ],
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "storeStatusItem" },
                          [
                            _c("div", { staticClass: "storeStatusItemTitle" }, [
                              _vm._v(
                                _vm._s(_vm.$t("dashboard.activeStoreTarget"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "storeStatusItemContent" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "storeStatusItemContentNum" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.storeData.activeCount || "-")
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        " /" +
                                          _vm._s(
                                            _vm.storeData.activeTargetCount ||
                                              "-"
                                          )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "storeStatusItemContentRate" },
                                  [
                                    _vm.storeData.activeRateNum >= 100
                                      ? _c("img", {
                                          attrs: {
                                            src: require("@/assets/sfe/sfe-icon.png"),
                                            alt: "",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        class:
                                          "" +
                                          (_vm.storeData.activeRateNum >= 100
                                            ? "overNum"
                                            : ""),
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.storeData.activeRate) + "%"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("el-progress", {
                              attrs: {
                                percentage: _vm.standardPercent(
                                  _vm.storeData.activeRateNum
                                ),
                                "show-text": false,
                                "stroke-width": 20,
                                "define-back-color": "#FEDB00",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "storeStatusItem" },
                          [
                            _c("div", { staticClass: "storeStatusItemTitle" }, [
                              _vm._v(
                                _vm._s(_vm.$t("dashboard.signStoreTarget"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "storeStatusItemContent" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "storeStatusItemContentNum" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.storeData.signingCount || "-"
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        " /" +
                                          _vm._s(
                                            _vm.storeData.signingTargetCount ||
                                              "-"
                                          )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "storeStatusItemContentRate" },
                                  [
                                    _vm.storeData.signRateNum >= 100
                                      ? _c("img", {
                                          attrs: {
                                            src: require("@/assets/sfe/sfe-icon.png"),
                                            alt: "",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        class:
                                          "" +
                                          (_vm.storeData.signRateNum >= 100
                                            ? "overNum"
                                            : ""),
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.storeData.signRate) + "%"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("el-progress", {
                              attrs: {
                                percentage: _vm.standardPercent(
                                  _vm.storeData.signRateNum
                                ),
                                "show-text": false,
                                "stroke-width": 20,
                                "define-back-color": "#FEDB00",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "tip" }, [
                          _c("i", { staticClass: "el-icon-warning-outline" }),
                          _vm._v(_vm._s(_vm.$t("dashboard.storeTip"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isSales !== "store",
                          expression: "isSales !== 'store'",
                        },
                      ],
                      staticClass: "echarts300 echarts300Scale mt_revers20",
                      attrs: { id: "id_salesCompRate" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      style: _vm.isSales !== "store" ? "margin-top:-20px" : "",
                    },
                    [
                      _vm.isSales === "integral"
                        ? _c("IntegralTextBoard", {
                            attrs: {
                              "source-data": _vm.saleIntegralData,
                              type: _vm.isSales,
                            },
                          })
                        : _vm.isSales !== "store"
                        ? _c("SaleTextBoard", {
                            attrs: {
                              "source-data": _vm.saleDisplayData,
                              type: _vm.isSales,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("HeaderMore", {
                    staticClass: "mt_20",
                    attrs: { title: _vm.$t("dashboard.target"), "no-more": "" },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("TargetValue", {
                            attrs: {
                              theme: "LUX",
                              "item-data": _vm.target_LUX,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("TargetValue", {
                            attrs: {
                              theme: "SUV",
                              "item-data": _vm.target_SUV,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("TargetValue", {
                            attrs: { theme: "EV", "item-data": _vm.target_EV },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("HeaderMore", {
                    staticClass: "mt_20",
                    attrs: { title: _vm.$t("dashboard.mix"), "no-more": "" },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("MixBoard", {
                            attrs: {
                              title: "18+",
                              theme: "blue",
                              "item-data": _vm.mixData_18,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("MixBoard", {
                            attrs: {
                              title: "19+",
                              theme: "blue",
                              "is-show-aop": false,
                              "item-data": _vm.mixData_19,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("MixBoard", {
                            attrs: {
                              title: "20+",
                              theme: "blue",
                              "is-show-aop": false,
                              "item-data": _vm.mixData_20,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("HeaderMore", {
                    staticClass: "mt_20",
                    attrs: {
                      title: _vm.$t("dashboard.newProduct"),
                      "no-more": "",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "new-products" },
                    [
                      _vm._l(_vm.newProductsData, function (product, pIndex) {
                        return _c(
                          "div",
                          { key: pIndex, staticClass: "new-product-item" },
                          [
                            _c(
                              "div",
                              { staticClass: "light-blue-board" },
                              [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(product.title)),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "values" }, [
                                  _c("div", { staticClass: "nums" }, [
                                    _c("span", { staticClass: "num1 blue" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.paddingNum(product.actualCount) ==
                                            0
                                            ? "-"
                                            : _vm.paddingNum(
                                                product.actualCount
                                              )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "space" }, [
                                      _vm._v("/"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "num2" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.paddingNum(product.aopCount) == 0
                                            ? "-"
                                            : _vm.paddingNum(product.aopCount)
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.paddingNum(product.aopCount) == 0
                                            ? "-"
                                            : _vm.paddingNum(product.finishRate)
                                        ) +
                                        "%\n                  "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("el-progress", {
                                  attrs: {
                                    percentage:
                                      product.finishRate > 100
                                        ? 100
                                        : product.finishRate,
                                    color: "#004EA8",
                                    "show-text": false,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.newProductsData.length % 3 === 2
                        ? _c("div", { staticClass: "new-product-item" })
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "wrap-container right-container" }, [
        _c(
          "div",
          { staticClass: "wrap-container-item" },
          [
            _c(
              "InfoItem",
              {
                attrs: {
                  title: "" + _vm.$t("storeComponents.title.order"),
                  "without-drop": "",
                },
              },
              [
                _c("div", { staticClass: "flexRow margin-b" }, [
                  _c(
                    "div",
                    { staticClass: "queryLabel" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "orderDataForm",
                          staticClass: "formGroup",
                          attrs: {
                            model: _vm.orderForm,
                            size: "small",
                            "label-position": "top",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("FormDatePicker", {
                                attrs: {
                                  val: _vm.orderForm.month,
                                  valueformat: "yyyyMM",
                                  type: "month",
                                  clearable: false,
                                  editable: false,
                                  placeholder: _vm.$t(
                                    "storeComponents.common.pleaseSelectMonth"
                                  ),
                                },
                                on: {
                                  "update:val": function ($event) {
                                    return _vm.$set(
                                      _vm.orderForm,
                                      "month",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flexRight" }, [
                    _c("div", { staticClass: "progressGroup" }, [
                      _c(
                        "div",
                        { staticClass: "pItem" },
                        [
                          _c("div", { staticClass: "pLabel" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "storeComponents.common.targetSalesMonth"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("el-progress", {
                            staticClass: "pProgress",
                            attrs: {
                              percentage: _vm.orderPecent.salesTargetQty,
                              color: "#004EA8",
                              "stroke-width": 16,
                              "show-text": false,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "pNumber" }, [
                            _vm._v(
                              _vm._s(
                                "" +
                                  _vm.paddingNum(
                                    _vm.orderStatus.salesTargetQty
                                  ) +
                                  _vm.$t("storeComponents.title.item2")
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pItem" },
                        [
                          _c("div", { staticClass: "pLabel" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("storeComponents.common.numberOfOrders")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("el-progress", {
                            staticClass: "pProgress",
                            attrs: {
                              percentage: _vm.orderPecent.orderQty,
                              color: "#A7CAF2",
                              "stroke-width": 16,
                              "show-text": false,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "pNumber" }, [
                            _vm._v(
                              _vm._s(
                                "" +
                                  _vm.paddingNum(_vm.orderStatus.orderQty) +
                                  _vm.$t("storeComponents.title.item2")
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pItem" },
                        [
                          _c("div", { staticClass: "pLabel" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "storeComponents.common.numberOfConfirmations"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("el-progress", {
                            staticClass: "pProgress",
                            attrs: {
                              percentage: _vm.orderPecent.confirmedQty,
                              color: "#FEDB00",
                              "stroke-width": 16,
                              "show-text": false,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "pNumber" }, [
                            _vm._v(
                              _vm._s(
                                "" +
                                  _vm.paddingNum(_vm.orderStatus.confirmedQty) +
                                  _vm.$t("storeComponents.title.item2")
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wrap-container-item" },
          [
            _c(
              "InfoItem",
              {
                attrs: {
                  title: "" + _vm.$t("storeComponents.title.store"),
                  "without-drop": "",
                },
              },
              [
                _c("Shop", {
                  staticClass: "mt_10 mb_30",
                  attrs: {
                    "source-data": _vm.storeAllData,
                    form: _vm.storeForm,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wrap-container-item flex-1" },
          [
            _c(
              "InfoItem",
              {
                attrs: {
                  title: "" + _vm.$t("storeComponents.title.visitReport"),
                  "without-drop": "",
                },
              },
              [
                _c("div", { staticClass: "flexRow" }, [
                  _c(
                    "div",
                    { staticClass: "queryLabel" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "reportDataForm",
                          staticClass: "formGroup",
                          attrs: {
                            model: _vm.reportForm,
                            size: "small",
                            "label-position": "top",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("FormDatePicker", {
                                attrs: {
                                  val: _vm.reportForm.month,
                                  valueformat: "yyyyMM",
                                  type: "month",
                                  clearable: false,
                                  editable: false,
                                  placeholder: _vm.$t(
                                    "storeComponents.common.pleaseSelectMonth"
                                  ),
                                },
                                on: {
                                  "update:val": function ($event) {
                                    return _vm.$set(
                                      _vm.reportForm,
                                      "month",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flexRight" }, [
                    _c("div", { staticClass: "visitReportTitle" }, [
                      _vm._v(
                        _vm._s(_vm.$t("storeComponents.title.visitReportTitle"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "visitReportContent" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.paddingNum(_vm.monthVisitReport.visitQty)
                          ) + _vm._s(_vm.$t("storeComponents.title.item2"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          " /" +
                            _vm._s(
                              _vm.paddingNum(_vm.monthVisitReport.visitDayQty)
                            ) +
                            _vm._s(_vm.$t("storeComponents.title.item3"))
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            "is-show": _vm.showSalary,
            width: "400px",
            "destroy-on-close": "",
            "is-only-confirm": "",
            "custom-title": _vm.$t("dashboard.bonus.title"),
          },
          on: {
            "update:isShow": function ($event) {
              _vm.showSalary = $event
            },
            "update:is-show": function ($event) {
              _vm.showSalary = $event
            },
          },
        },
        [
          _c("div", [
            _c("div", [_vm._v(_vm._s(_vm.$t("dashboard.bonus.bonusMonth")))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "salaryContent" },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    model: {
                      value: _vm.bonusMonth,
                      callback: function ($$v) {
                        _vm.bonusMonth = $$v
                      },
                      expression: "bonusMonth",
                    },
                  },
                  _vm._l(
                    _vm.lookupList["BONUS_CALCULATION_MONTH"],
                    function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.code },
                      })
                    }
                  ),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("dashboard.bonus.salary")))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "salaryContent" },
              [
                _c("el-input", {
                  attrs: { type: "number" },
                  model: {
                    value: _vm.salary,
                    callback: function ($$v) {
                      _vm.salary = $$v
                    },
                    expression: "salary",
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      size: "small",
                      plain: "",
                      type: _vm.salary ? "primary" : "",
                    },
                    on: { click: _vm.onBonusCalculation },
                  },
                  [_vm._v(_vm._s(_vm.$t("dashboard.bonus.button")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("dashboard.bonus.bonus")))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "salaryContent" },
              [
                _c("el-input", {
                  attrs: { value: _vm.salaryRes, disabled: "" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "tip" }, [
              _c("i", { staticClass: "el-icon-warning-outline" }),
              _vm._v(_vm._s(_vm.$t("dashboard.bonus.tip"))),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }